import { InvitationsApi } from '@calm/evexia-web-sdk/generated/lib/api/invitations-api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `InvitationsApi`
 * @param accessToken
 * @returns
 */
export default function createInvitationsApi(
    accessToken: () => Promise<string>
) {
    return createApi(InvitationsApi, accessToken);
}
